import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Container, Row, Col } from 'react-bootstrap';
import { compose } from 'utils/react';
import stylesGlobal from 'theme/facility-globals.scss';
import { OPTION_DEFAULT } from '../../../../../website/widgets/dynamic/PayOnline/properties';
import { section, editModal } from '../decorators';
import Editor from './Editor/Editor';

const PayOnline = ({ isBuilderView, payOption, children }) => {
  const [PayOnlineWidget] = React.Children.toArray(children);

  return (
    <div className={`${stylesGlobal.section} ${stylesGlobal.sectionNoPadBtm}`}>
      <Container>
        <Row>
          <Col md={12} sm={24}>
            {React.cloneElement(PayOnlineWidget, { isBuilderView, payOption })}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

PayOnline.propTypes = {
  isBuilderView: PropTypes.bool,
  payOption: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

const component = compose(
  editModal(
    props => ({
      title: 'Pay Online',
      initialValues: {
        payOption: props.payOption || OPTION_DEFAULT,
      },
    }),
    props => (
      [{
        children: (
          <div>
            <Field
              component={Editor}
              name="payOption"
              payOption={props.payOption}
            />
          </div>
        ),
      }]
    ),
  ),
  section(
    {
      name: 'Pay Online',
      category: 'Pay Online',
    },
    {
      subsections: [{ accepts: 'PayOnline' }],
      defaults: ['PayOnline'],
      menu: { items: ['edit', 'delete'] },
    },
  ),
)(PayOnline);

export default component;
